export const formBuilder = [
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Equity Issuer Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Issuer Legal Description', fieldName:'issue_description', required:true},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'issuer_street_address_1'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'issuer_street_address_2'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'City', fieldName:'issuer_city'},
    {type:'textinput',width:'w-1/2',fieldLabel:'State', fieldName:'issuer_state'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Postcode', fieldName:'issuer_postcode'},
    {type:'countryselect',width:'w-1/2',fieldLabel:'Country of Domicile', fieldName:'issuer_country', required: true,
        possibleValues:[{value:'CW','label':'Curacao'}, {value:'AU','label':'Australia','disabled':false}]},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Source Document', fieldName:'issuer_source_document',
        possibleValues:[
            {value:'','label':''},
            {value:'010','label':'Assignment Letter (PPN only)'},
            {value:'020','label':'Board Of Directors Resolution'},
            {value:'030','label':'Certificate'},
            {value:'040','label':'Certificate Of Amendment'},
            {value:'045','label':'Contract'},
            {value:'050','label':'Court Order'},
            {value:'060','label':'Credit Agreement'},
            {value:'070','label':'Disclosure Statement (Bankruptcy)'},
            {value:'080','label':'Exchange Offer'},
            {value:'085','label':'Extension Letter'},
            {value:'090','label':'15C2-11 (Due Diligence)'},
            {value:'100','label':'Final Offering Circular'},
            {value:'105','label':'Final Offering Memorandum'},
            {value:'120','label':'Final Prospectus'},
            {value:'110','label':'Final Private Placement Memorandum'},
            {value:'125','label':'Form Of Bond'},
            {value:'127','label':'Form Of Note'},
            {value:'129','label':'Form 8-A'},
            {value:'130','label':'Indenture'},
            {value:'140','label':'Joint Proxy/Prospectus'},
            {value:'143','label':'Lease Agreement'},
            {value:'150','label':'Loan Agreement'},
            {value:'160','label':'Minutes Of Shareholders Meeting'},
            {value:'170','label':'Notice Of Redemption'},
            {value:'180','label':'Notice To Shareholders'},
            {value:'190','label':'N-1 Registration Statement'},
            {value:'200','label':'N-1 A Registration Statement'},
            {value:'210','label':'N-2 Registration Statement'},
            {value:'215','label':'Partnership Agreement (PPN)'},
            {value:'220','label':'Plan Of Merger'},
            {value:'230','label':'Plan Of Reorganization'},
            {value:'240','label':'Preliminary Offering Circular'},
            {value:'245','label':'Preliminary Offering Memorandum'},
            {value:'260','label':'Preliminary Prospectus'},
            {value:'250','label':'Preliminary Private Placement Memorandum'},
            {value:'270','label':'Press Release'},
            {value:'280','label':'Pricing Wire'},
            {value:'290','label':'Prospectus Supplement'},
            {value:'300','label':'Proxy Statement'},
            {value:'310','label':'Purchase Agreement'},
            {value:'320','label':'S-1 Registration Statement'},
            {value:'330','label':'S-3 Registration Statement'},
            {value:'340','label':'S-4 Registration Statement'},
            {value:'350','label':'S-6 Registration Statement'},
            {value:'360','label':'SB-2 Registration Statement'},
            {value:'370','label':'Term Sheet'},
            {value:'380','label':'U-7 Disclosure Statement'},
            {value:'390','label':'Warrant Agreement'},
        ]
    },
    {type:'textinput',width:'w-1/2',fieldLabel:'Lead Underwriter', fieldName:'issuer_underwriter'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Counsel', fieldName:'issuer_counsel'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Transfer Agent', fieldName:'issuer_transfer_agent'},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Issuer Contact Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'First Name', fieldName:'issuer_firstname'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Last Name', fieldName:'issuer_lastname'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Email Address', fieldName:'issuer_email', required:true},
    {type:'textinput',width:'w-1/2',fieldLabel:'Phone Number', fieldName:'issuer_phone'},
]

export const formBuilder2 = [
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Equity Issue Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Issue Description', fieldName:'issuer_legal_description' },
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Underlying Instrument', fieldName:'underlying_instrument' },
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Currency' , fieldName:'issue_currency'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Where Traded', fieldName:'issue_traded'},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Initial Public Offering?', fieldName:'issue_ipo',
        possibleValues:[{value:'','label':'-'}, {value:true,'label':'Yes'}, {value:false,'label':'No'}]},

    {type:'selectinput',width:'w-1/2',fieldLabel:'Depository Eligible?', fieldName:'issue_depository',
        possibleValues:[{value:'','label':'-'}, {value:true,'label':'Yes'}, {value:false,'label':'No'}]},

    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Payment Status', fieldName:'issue_payment_status',
        possibleValues:[{value:'','label':'-'},
            {value:'N','label':'Fully Paid. No PAR Value'},
            {value:'O','label':'Nil Paid'},
            {value:'P','label':'Partly Paid'},
            {value:'V','label':'Fully Paid PAR Value'}
        ]},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Owner Restrictions', fieldName:'issue_owner_restrictions',
        possibleValues:[{value:'','label':'-'},
            {value:'U','label':'Unrestricted'},
            {value:'R','label':'Restricted'},
        ]},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Voting Rights', fieldName:'issue_voting_rights',
        possibleValues:[{value:'','label':'-'},
            {value:'V','label':'Voting Rights'},
            {value:'N','label':'Non-Voting'},
            {value:'R','label':'Restricted Vote'},
            {value:'E','label':'Enhanced Vote'},
            {value:'S','label':'Sub Voting'},
        ]},
    {type:'textinput',width:'w-1/2',fieldLabel:'Ticker Symbol', fieldName:'issue_ticker_symbol'},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:' '},

    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:'Instrument LEI Details'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Issuer LEI' , fieldName:'issuer_lei'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Fund Manager LEI', fieldName:'fund_manager_lei'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Head Office Name' , fieldName:'head_office_name'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Head Office LEI', fieldName:'head_office_lei'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'CSD Name' , fieldName:'csd_name'},
    {type:'textinput',width:'w-1/2',fieldLabel:'CSD LEI', fieldName:'csd_lei'},

    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:'Funds Only'},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Fund Type', fieldName:'issue_fund_type',
        possibleValues:[{value:'','label':'-'},
            {value:'O','label':'Open End'},
            {value:'C','label':'Closed End'},
        ]},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Fund Investment Policy', fieldName:'issue_investment_policy',
        possibleValues:[{value:'','label':'-'},
            {value:'R','label':'Real Estate'},
            {value:'S','label':'Security'},
            {value:'M','label':'Mixed General'},
            {value:'C','label':'Commodities'},
            {value:'D','label':'Derivatives'},
            {value:'A','label':'Capital Apprec.'},
            {value:'Y','label':'Growth'},
            {value:'W','label':'Growth &amp; Income'},
            {value:'Q','label':'Equity Income'},
            {value:'L','label':'Small Co. Growth'},
            {value:'P','label':'MID CAP'},
            {value:'H','label':'Health / Biotech'},
            {value:'N','label':'Natural Res.'},
            {value:'E','label':'Environment'},
            {value:'T','label':'Science &amp; Tech.'},
            {value:'U','label':'Utility'},
            {value:'F','label':'Finl. Services'},
            {value:'G','label':'Precious Metals'},
            {value:'B','label':'Global'},
            {value:'I','label':'International'},
            {value:'X','label':'State Taxable BD'},
            {value:'V','label':'Intermed. Tax. BD'},
            {value:'Z','label':'Long Term Tax BD'},
            {value:'J','label':'High Yield Tax. BD'},
            {value:'K','label':'Mortg.-Backed BD'},
            {value:'O','label':'Municipal Bonds'},
        ]},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Fund Form', fieldName:'issue_fund_form',
        possibleValues:[{value:'','label':'-'},
            {value:'L','label':'Front Load'},
            {value:'O','label':'No Load'},
            {value:'D','label':'Back Load'},
        ]},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:' '},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:'Preferred Stock Only', fieldName:'issue_preferred_stock_only'},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Preferred Type', fieldName:'issue_preferred_type',
        possibleValues:[{value:'','label':'-'},
            {value:'R','label':'Redeemable'},
            {value:'E','label':'Exchangeable'},
            {value:'T','label':'Extendible'},
            {value:'A','label':'Red Exchg. Extd.'},
            {value:'B','label':'Redeemable Extd'},
            {value:'C','label':'Redeemable Exch'},
            {value:'L','label':'Exch Extendible'},
            {value:'N','label':'Non Red Exch Extd'},
        ]},
    {type:'InputRow',width:'w-full'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Callable', fieldName:'issue_callable',
        possibleValues:[{value:'','label':'-'},
            {value:'Y','label':'Yes'},
            {value:'N','label':'No'},
            {value:'Z','label':'Not Applicable'},
            {value:'X','label':'Not Available'},
        ]},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Preferred type Dividend Income', fieldName:'issue_dividend_income',
        possibleValues:[{value:'','label':'-'},
            {value:'F','label':'Fixed Rate Income'},
            {value:'C','label':'Cumulative Fixed Rate'},
            {value:'P','label':'Paticipating Income'},
            {value:'Q','label':'Cumulative Part. Income'},
            {value:'A','label':'Adjustable Rate Income'},
            {value:'U','label':'Auction Rate'},
            {value:'N','label':'Normal Rate income'},
        ]},
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-1/2',fieldLabel:'Warrants and Rights Only'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Expiration Date', fieldName:'interest_rate'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Expiration Date', fieldName:'issue_expiration'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Special Instructions', fieldName:'issue_special_instructions'},

    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Additional Information', fieldName:'isin_additional_info'},
]

export const formBuilder3 = [
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Requester Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'First Name', fieldName:'requester_firstname'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Last Name', fieldName:'requester_lastname'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Email', fieldName:'requester_email', required:true},
    {type:'textinput',width:'w-1/2',fieldLabel:'Phone Number', fieldName:'requester_phone'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Company Name', fieldName:'requester_company'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'requester_street_address'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'requester_street_address_2'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'City', fieldName:'requester_city'},
    {type:'textinput',width:'w-1/2',fieldLabel:'State', fieldName:'requester_state'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Postcode', fieldName:'requester_postcode'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Country', fieldName:'requester_country', possibleValues:[{value:'CW','label':'Curacao','disabled':false}, {value:'AU','label':'Australia','disabled':false}]},
]

export const formBuilder4 = [
    {type:'InputRow',width:'w-full'},
    {type:'sectionHeading',width:'w-full',fieldLabel:'Billing Information'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'First Name', fieldName:'billing_firstname'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Last Name', fieldName:'billing_lastname'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Email', fieldName:'billing_email'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Phone Number', fieldName:'billing_phone'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Company Name', fieldName:'billing_company'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'billing_street_address'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-full',fieldLabel:'Street Address', fieldName:'billing_street_address_2'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'City', fieldName:'billing_city'},
    {type:'textinput',width:'w-1/2',fieldLabel:'State', fieldName:'billing_state'},
    {type:'InputRow',width:'w-full'},
    {type:'textinput',width:'w-1/2',fieldLabel:'Postcode', fieldName:'billing_postcode'},
    {type:'selectinput',width:'w-1/2',fieldLabel:'Country', fieldName:'billing_country', possibleValues:[{value:'CW','label':'Curacao','disabled':false}, {value:'AU','label':'Australia','disabled':false}]},
]



// WEBPACK FOOTER //
// ./src/main/content/isinApplications/isinFormFields.js